import SideTabNavigator from './SideTabNavigator'

export default SideTabNavigator
